<template>
  <v-container fluid class="pa-0">
    <v-layout row wrap>
      <v-flex xs4 sm4>
        <article class="panelLogar">
          <v-layout column align-center justify-center class="white--text">
            <span style="cursor: pointer" title="Motor Fiscal" @click="$router.push('/')">
              <img
                class="logoMotor"
                src="@/assets/images/logo_transparente/÷cone Negativo.png"
                alt="Logo motor"
                height="100"
                style="margin-left: -3px;"
              >
              <h1
                class="white--text mb-4 display-1 text-xs-center"
                style="color: white;font-weight: 500;"
              >
                <span style="color:#00a3a3; font-weight: 800;letter-spacing: 2px!important;">M</span>otor Fiscal
              </h1>
            </span>
            
            <div style="margin-top: 130px;">
              <span>Já tem cadastro ?</span>
              <v-btn
                color="primary_custom"
                class="btnLogar"
                block
                @click="$router.push('/login')"
              >Logar</v-btn>
            </div>
          </v-layout>
        </article>
      </v-flex>
      <v-flex xs8 sm8>
        <v-stepper  v-model="e1">
          <v-layout row justify-center>
            <h1 style="color: dimgrey;">Cadastrar</h1>
          </v-layout>
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Usuário</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2">Empresa</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step v-if="!envCert" :complete="e1 > 3" step="3">Conta</v-stepper-step>
            <v-stepper-step v-else :complete="certCadastrado" step="3">Certificado</v-stepper-step>
          </v-stepper-header>


          <v-stepper-items>
            <v-stepper-content @keydown.enter.native="UserIsValid ? avançarStep($event) : ''" step="1">
              <v-card class="mb-5" height="300px">
                <pre-cadastro-usuario @getUsuario="getUsuario($event)"></pre-cadastro-usuario>
              </v-card>
              <router-link to="/">
                <v-btn color="indigo" tabindex="5" outline>Cancelar</v-btn>
              </router-link>
              <v-btn
                color="primary"
                ref="btn_avan_user"
                @click="avançarStep($event)"
                v-bind:disabled="!UserIsValid"
                tabindex="4"
              >Continuar</v-btn>
            </v-stepper-content>

            <v-stepper-content @keydown.enter.native="EmpIsValid ? avançarStep($event) : ''" step="2">
              <v-progress-linear  v-if="loading" color="teal" height="10" indeterminate style="z-index: 3;padding: 0;margin: 0;"></v-progress-linear>
              <v-card class="mb-5" height="200px">
                <pre-cadastro-empresa @getEmpresa="getEmpresa($event)"></pre-cadastro-empresa>
                <div id="cadastroContaCheckbox">
                <v-checkbox
                  v-model="envCert"
                  label="Deseja vincular certificado agora ?"
                  color="success"
                  value="success"
                  hide-details
                ></v-checkbox>
                </div>
              </v-card>
              <v-btn outline color="indigo" @click="retornarStep()">Voltar</v-btn>
              <v-btn
                ref="btn_avan_emp"
                id="btn_avan_emp"
                class="btnCadastrar"
                color="warning"
                @click="avançarStep($event)"
                v-bind:disabled="!EmpIsValid"
              >Cadastrar</v-btn>
            </v-stepper-content>

            <v-stepper-content v-if="!envCert" step="3">
             <v-progress-linear v-if="loading" color="teal" height="10"  indeterminate style="z-index: 3;padding: 0;margin: 0;"></v-progress-linear>

              <v-card class="mb-5" color="grey lighten-1" height="200px">
                <h2
                  class="text-xs-center"
                  :class="colorOfMessage"
                  style="background-color: #f3f3f3!important;line-height: 187px;"
                >{{message}}</h2>
                <v-divider
                  class="mx-2"
                  inset
                  
                ></v-divider>
              </v-card>
              <v-btn class="btnLogar" color="primary_custom" @click.native="finalizar()">Finalizar</v-btn>
          
            </v-stepper-content>

            <v-stepper-content v-else step="3">
              <v-progress-linear v-if="loading" color="teal" height="10"  indeterminate style="z-index: 3;padding: 0;margin: 0;"></v-progress-linear>
              <v-card class="mb-5" height="150px">
                <h2
                  class="text-xs-center"
                  :class="colorOfMessage"
                  style="background-color: #f3f3f3!important;"
                >{{message}}</h2>
                <v-divider
                style="margin-bottom: 10px;"
                ></v-divider>

                <InputFile
                  id="empresa-file"
                  :component="'certificado'"
                  :prevIcon="'description'"
                  :text="'Selecione um certificado'"
                  @getFile="getFile($event)"
                ></InputFile>

                <v-text-field
                  ref="passCert"
                  :class="this.cert.file != undefined ? 'input-required' : ''"
                  v-model="cert.password"
                  label="Senha:"
                  id="empresa-password"
                  :disabled="this.cert.file == undefined || this.certCadastrado"
                  :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  :rules="passRules"
                  validate-on-blur
                  @input="checkCertValid($event);"
                  clearable
                  required
                ></v-text-field>
              </v-card>
              <v-btn outline color="indigo" v-if="this.erroCadastro" @click="retornarStep()">Voltar</v-btn>
              
              <v-btn class="btnLogar" outline color="yellow darken-3" @click.native="finalizar()">Finalizar sem vincular certificado</v-btn>
              
              <v-btn
                class="btnCadastrar"
                color="warning"
                ref="btn_avan_user"
                @click="vincular()"
                v-bind:disabled="!certValido"
                tabindex="4"
              >Vincular certificado</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PreCadastroEmpresa from "@/components/conta/precadastro/Empresa.vue";
import PreCadastroUsuario from "@/components/conta/precadastro/Usuario.vue";
import Menu from "@/components/menu/Menu.vue";
import InputFile from "@/components/shared/inputFile/InputFile.vue";
import CertificadoService from "@/domain/conta/empresa/certificado/CertificadoService.js";
import GravatarService from "@/domain/gravatar/GravatarService.js";
import PreConta from "@/domain/conta/PreConta.js";
import Empresa from "@/domain/conta/empresa/Empresa.js";
import Usuario from "@/domain/conta/usuario/Usuario.js";
import Certificado from "@/domain/conta/empresa/certificado/Certificado.js";
export default {
  components: {
    preCadastroEmpresa: PreCadastroEmpresa,
    preCadastroUsuario: PreCadastroUsuario,
    mainMenu: Menu,
    InputFile: InputFile
  },
  data() {
    return {
      e1: 0,
      cert: { file: undefined, password: "", empresa: [] },
      preConta: new PreConta(new Empresa(), new Usuario(), new Certificado()),
      file_cert: "",
      step: { usuario: false, empresa: false, cert: false },
      message: "Não conseguimos cadastrar sua conta",
      colorOfMessage: "red--text",
      passRules: [],
      showPassword: false,
      erroCadastro: false,
      conta: undefined,
      certCadastrado: false,
      envCert: false,
      loading: false
    };
  },
  computed: {
    UserIsValid: function() {
      return this.step.usuario === true;
    },
    EmpIsValid: function() {
      return this.step.empresa === true;
    },
    certValido: function() {
      return this.step.cert === true;
    }
  },
  methods: {
    getFile(file) {
      this.cert.file = file[0];
      this.setRequiredPass();
    },
    checkCertValid() {
      if (this.cert.file != undefined && this.$refs.passCert.validate()) {
        this.step.cert = true;
      } else {
        this.step.cert = false;
      }
    },
    finalizar(){
      if(this.erroCadastro == false){
        let conta = {};
        this.loading = true;
        conta["email"] = this.preConta.usuario.email;
        conta["password"] = this.preConta.usuario.password;
        let body = JSON.stringify(conta);
        this.$http.post("usuarios/authenticate", body).then(
          success => {
            this.loading = false;
            this.redirectUser(success);
          },
          failed => {
            this.loading = false;
            let router = this.$router;
              router.push("/login");
          }
        );
      }else{
        this.$router.push("/login");
      }
    },
     redirectUser: async function(success) {
      this.$session.start();
      let conta = success.body;
      this.service = new GravatarService(this.$http);
      this.loading = true;
      await this.service
        .getGravatar(success.body.email)
        .then(
          success => {
            conta["gravatarProfile"] = success;
          },
          failed => {}
        )
        .then(x => {
          this.loading = false;
          this.$session.set("jwt", conta);
          this.$router.push("/DashBoard");
        });
    },
    vincular() {
      this.service = new CertificadoService(this.$http);
      this.loading = true;
      this.service.cadastrar(this.cert, this.conta._id).then(resp => {
         this.loading = false;
        if (resp.ok) {
          this.message = resp.infoMessage.msg;
          this.colorOfMessage = "green--text";
          this.certCadastrado = true;
          this.step.cert = false;
          this.envCert = false;
        } else {
          this.colorOfMessage = "red--text";
          resp.body.message != undefined && resp.body.message.length != 0
            ? (this.message= resp.body.message)
            : (this.message= resp.infoMessage.msg);
        }
      });
    },
    setRequiredPass: function() {
      if (
        this.passRules.length > 0 &&
        this.passRules[this.passRules.length - 1].name.length != 0
      ) {
        this.passRules.pop();
      }

      if (this.cert.file != undefined) {
        this.passRules.push(function obrigatorio(value) {
          if (!value || value.length == 0) {
            return "Campo obrigatório";
          }
          return true;
        });
      }
      this.$refs.passCert.validate();
    },
    getUsuario: function($event) {
      if ($event) {
        this.preConta.usuario = $event;
        this.step.usuario = true;
      } else {
        this.step.usuario = false;
      }
    },
    getEmpresa: function($event) {
      if ($event) {
        //popula as variaveis com os dados de retorno
        for (var i = 0; i < $event.length; i++) {
          if ($event[i].cnpj) {
            this.preConta.empresa = $event[i];
          } else if ($event[i].file) {
            this.preConta.certificado = $event[i];
            this.file_cert = $event[i].file;
          }
        }
        this.step.empresa = true;
      } else {
        this.step.empresa = false;
      }
    },
    cadastraConta: async function() {
      //Criação do form Data para passar os dados no cadastro
      this.loading = true;
      const data = new FormData();
      if (
        this.file_cert != undefined &&
        this.file_cert != null &&
        this.file_cert.length > 0
      ) {
        data.append("file", this.file_cert);
      }
      data.append("plano", JSON.stringify(this.preConta.usuario.plano));
      data.append("cert", JSON.stringify(this.preConta.certificado));
      data.append("usuario", JSON.stringify(this.preConta.usuario));
      data.append("empresa", JSON.stringify(this.preConta.empresa));

      this.resource = this.$resource(
        "contas/pre",
        {},
        {},
        { emulateJSON: true }
      );
      await this.resource.save({}, data).then(
        success => {
          this.loading = false;
          this.envCert == false ? this.message = "Sua conta foi cadastrada." : this.message = "Sua conta foi cadastrada, falta apenas o certificado.";
          this.colorOfMessage = "green--text";
          this.conta = success.body;
          this.erroCadastro = false;
          this.cert.empresa.push(success.body.empresas[0].empresa._id);
        },
        failed => {
          this.loading = false;
          this.erroCadastro = true;
          this.conta = undefined;
        }
      );
    },
    avançarStep: async function(e) {
      switch (this.e1) {
        case 1:
          break;
        case 2:
          await this.cadastraConta();
          break;
        case 3:
          break;
      }
      this.e1++;
    },
    retornarStep: function() {
      this.$refs.btn_avan_user.disabled = false;
     
      switch (this.e1) {
        case 2:
          this.$refs.btn_avan_user.disabled = false;
          break;
        case 3:
          break;
      }
      this.e1--;
    }
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}
.btnLogar.primary_custom {
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(#167327),
    to(#0ad415)
  );
  color: white !important;
  border: thin solid black;
}
.btnCadastrar.v-btn--disabled.warning {
  background: unset;
}
.btnCadastrar.warning {
  background: -webkit-gradient(
    linear,
    left bottom,
    left top,
    from(#0f7e08),
    to(#69b46f)
  );
  color: white !important;
  border: thin solid black !important;
}
.logoMotor {
  animation: logo 1s infinite alternate;
}
@-moz-keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
@-webkit-keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
@-o-keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
@keyframes logo {
  from {
    transform: translate(0%, -2%);
  }
  to {
    transform: translate(0%, -23%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/guestArea/novaConta/NovaConta.vue